export default {
    hardCapsTitle: 'Hard Caps',
    hardCapsMenu: 'Hard Caps',
    hardCapsSubtitle: 'Absolute platform limits that cannot be exceeded by plan or add-ons',
    newHardCap: 'New hard cap',
    editHardCap: 'Edit hard cap',
    createHardCap: 'Create hard cap',
    hardCapModule: 'Module',
    hardCapAttribute: 'Attribute',
    hardCapMaxValue: 'Maximum value',
    hardCapDescription: 'Description',
    hardCapActive: 'Active',
    selectModule: 'Select a module',
    selectAttribute: 'Select an attribute',
    attributeImmutableHint: 'The module and attribute cannot be changed after creation',
    hardCapCreated: 'Hard cap created successfully',
    hardCapUpdated: 'Hard cap updated successfully',
    hardCapCreateError: 'Error creating the hard cap',
    hardCapUpdateError: 'Error updating the hard cap',
    hardCapLoadError: 'Error loading the hard caps',
    confirmDeleteHardCap: 'Are you sure you want to delete this hard cap? This action cannot be undone.',
    hardCapDeleted: 'Hard cap deleted successfully',
    hardCapDeleteError: 'Error deleting the hard cap',
    tableId: 'ID',
    tableStatus: 'Status',
    tableActions: 'Actions',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    validationModuleRequired: 'The module is required',
    validationAttributeRequired: 'The attribute is required',
    validationMaxValueRequired: 'The maximum value is required',
};
